import React from 'react'
import moment from 'moment-timezone'

import Badge from 'app/components/Badge'
import Star from 'app/components/SVGS/Star'
import GraphRow from './GraphRow'
import { ISprintProps } from './interface'
import { GRAPH_ROW_TYPES } from 'app/constants/sprints'
import './styles.scss'
import { getSprintEndPrefix } from 'helpers/sprints'

export const bc = 'sprint'

const Sprint = ({ timezone, userAvatar, organizationAvatar, sprint, t }: ISprintProps) => {
  if (sprint) {
    const user = sprint.get('user')
    const organization = sprint.get('organization')
    const endPrefix = getSprintEndPrefix(sprint.get('endDate'), timezone)

    return (
      <div className={`${bc}__wrapper`}>
        <div className={`${bc}__top`}>
          <div className={`${bc}__text`}>
            <div className={`${bc}__title`}>{sprint.get('title')}</div>
            <div className={`${bc}__subtitle`}>
              {`${endPrefix}: ${moment.tz(sprint.get('endDate'), 'UTC').format('Do MMM')}`}
            </div>
          </div>
          {sprint.get('badge') ? <Badge url={sprint.get('badge')} /> : <Star />}
        </div>
        {!user.isFinished && (
          <div className={`${bc}__bottom`}>
            <GraphRow avatar={userAvatar} actions={user.achievedPoints} goal={user.goal} type={GRAPH_ROW_TYPES.USER} />
            <GraphRow
              avatar={organizationAvatar}
              actions={organization.achievedPoints}
              goal={organization.goal}
              type={GRAPH_ROW_TYPES.ORG}
            />
          </div>
        )}
      </div>
    )
  }
  return null
}

export default Sprint as React.FunctionComponent<ISprintProps>
